import {
	enUS, frFR, zhCN, viVN, arSD,
} from '@mui/material/locale'
import { SettingsValueProps } from './components/settings/type'
import { SocialLinks } from './components/SocialsButton'
import { PATH_DASHBOARD } from './routes/paths'

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || ''

// export const localhostAlias = '192.168.7.47' // this does not work
// export const localhostAlias = 'localhost'
// export const localhostAlias = '127.0.0.1'
export const localhostAlias = 'unreal.local' // this is the name of Jeff's development machine

const preface = 'High utility NFTs'

export const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	// databaseURL: process.env.REACT_APP_DATABASE_URL,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

/* export const cognitoConfig = {
	userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
	clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
}

export const auth0Config = {
	clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
	domain: process.env.REACT_APP_AUTH0_DOMAIN,
} */

// ROOT PATH AFTER LOGIN SUCCESSFUL
// export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.nfts // as '/dashboard/app'
export const PATH_AFTER_LOGIN = '/dashboard/app'

// export const WHITELIST_CTA = 'Get Whitelisted'
export const WHITELIST_CTA = 'Whitelist My NFT'
export const mapConfig = process.env.REACT_APP_MAP_MAPBOX

export const googleAnalyticsConfig = process.env.REACT_APP_GOOGLE_ANALTYICS_ID

export const HEADER = {
	MOBILE_HEIGHT: 64,
	MAIN_DESKTOP_HEIGHT: 88,
	DASHBOARD_DESKTOP_HEIGHT: 92,
	DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
}

export const BACK_BAR = {
	MAIN_DESKTOP_HEIGHT: 40,
}

export const NAVBAR = {
	BASE_WIDTH: 260,
	DASHBOARD_WIDTH: 280,
	DASHBOARD_COLLAPSE_WIDTH: 88,
	//
	DASHBOARD_ITEM_ROOT_HEIGHT: 48,
	DASHBOARD_ITEM_SUB_HEIGHT: 40,
	DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
}

export const ICON = {
	NAVBAR_ITEM: 22,
	NAVBAR_ITEM_HORIZONTAL: 20,
}

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
	themeMode: 'dark',
	themeDirection: 'ltr',
	themeContrast: 'default',
	themeLayout: 'horizontal',
	themeColorPresets: 'default',
	themeStretch: false,
}

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
	{
		label: 'English',
		value: 'en',
		systemValue: enUS,
		icon: '/assets/icons/flags/ic_flag_en.svg',
	},
	{
		label: 'French',
		value: 'fr',
		systemValue: frFR,
		icon: '/assets/icons/flags/ic_flag_fr.svg',
	},
	{
		label: 'Vietnamese',
		value: 'vn',
		systemValue: viVN,
		icon: '/assets/icons/flags/ic_flag_vn.svg',
	},
	{
		label: 'Chinese',
		value: 'cn',
		systemValue: zhCN,
		icon: '/assets/icons/flags/ic_flag_cn.svg',
	},
	{
		label: 'Arabic (Sudan)',
		value: 'ar',
		systemValue: arSD,
		icon: '/assets/icons/flags/ic_flag_sa.svg',
	},
]

export const defaultLang = allLangs[0] // English

export const siteData = {
	twitterHandle: 'BodaciousNFTs',
	twitterTitle: 'Bodacious Bears',
	twitterDescription: 'An Interactive NFT',
	// twitterImageUrl: 'https://stickiesfundev.imgix.net/bodacious-bears/website/ogimage-twitter.png?fm=jpg&q=75',
	// twitterImageUrl: 'https://stickiesfundev.imgix.net/bodacious-bears/website/ogimage_2.png?fm=jpg&q=75',
	browserTabTitle: 'Unreal',
	siteTitle: 'Unreal',
	collectionEzName: 'Bodacious Bear',
	// siteDescription: 'An Interactive NFT',
	// siteDescription: 'Nurture. Compete. Earn.',
	// siteDescription: 'NFTs that compete for fame and fortune.',
	// siteDescription: 'Say Hello to a New Breed of NFTs.',
	siteDescription: `${preface}.`,
	// siteLongDescription: 'This collection of 10,000 stylistically curated, interactive NFTs delivers an elevated experience, powered by AI and a whole new level of social interactivity.',
	// siteLongDescription: '10,000 algorithmically generated NPC NFTs with needs, desires and personalities.',
	// siteLongDescription: 'A family of 10,000 algorithmically generated NFTs. When you own a Bodacious Bear, you\'ll have fun customizing your bear\'s interests and personality, while you raise it and watch your bear compete for fame and fortune.',
	// siteLongDescription: 'Say Hello to a New Generation of NFTs. Artificially Intelligent Virtual Pets that Entertain, Grow and Reproduce. Now Minting.',
	// siteLongDescription: 'Say Hello to a New Generation of NFTs. Artificially Intelligent Virtual Pets that Entertain, Grow and Reproduce. Now Minting.',
	siteLongDescription: `${preface}. Now Minting.`,
	// npcShareDescription: 'I\'m one in a collection of 10k unique, algorithmically generated NPC NFTs with needs, desires and personalities.',
	// npcShareDescription: 'A New Breed of NFT. An Artificially Intelligent Pet. Come Train Me!',
	// npcShareDescription: 'An Elite NFT.',
	npcShareDescription: '',
	// individualStickyDescription: 'Virtual Items with Value! By stickies.fun',
	// individualStickyDescription: 'NPC NFT',
	// Stickies are a great way to express yourself.
	// ogImageUrl: 'https://stickiesfundev.imgix.net/bodacious-bears/website/ogimage-sms.png?fm=jpg&q=75',
	// ogImageUrl: 'https://stickiesfundev.imgix.net/bodacious-bears/website/ogimage-twitter.png?fm=jpg&q=75',
	ogImageUrl: 'https://stickiesfundev.imgix.net/bodacious-bears/website/ogimage_2.png?fm=jpg&q=75',
	howToVideo: 'https://youtube.com/shorts/xskBIewpswA?feature=share',
	collection: 'bb1',
	dAppUrlNoHttp: `${process.env.REACT_APP_DAPP_ROOT_URL_NO_HTTP}`,
	iOSAppUrl: '',
	iOSTestFlightUrl: '',
	linkSentSignUpMessage: 'We sent a one-click sign-up link to',
	linkSentSignInMessage: 'We sent a one-click sign-in link to',
	bidLinkSentMessage: 'Check your email to secure your place in line.',
	finishPath: '/account/finish',
	finishBidPath: '/account/finishbid',
	finishSubscriptionPath: '/account/finishsubscription',
	shareButtonText: 'Share',
	bidButtonText: 'Make Bid',
	ownersDashboardUrl: 'https://my.bodaciousbears.com/',
	openSeaMarketplace: 'https://opensea.io/collection/bodaciousbears',
	twitterPage: 'https://twitter.com/MyUnrealNFT',
	whitepaper: 'https://docs.unreal.fun/whitepaper',
	wikiForCreators: 'https://docs.unreal.fun/creators',
	wikiForCollectors: 'https://docs.unreal.fun/collectors',
	instagramPage: 'https://instagram.com/bodacious_bears',
	discordPage: 'https://discord.gg/BJRjEVMdZ9',
	// telegramPage: 'https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxNzg3MTE3NjYy',
	telegramPage: 'https://t.me/unrealfun',
	wikiUrl: 'https://bodaciousbears.notion.site/Getting-Started-6b2e227b9f9e4e3fa63f85ca33046d66',
	wikiUrlRoot: 'https://bodaciousbears.notion.site',
	itemPrice: `${process.env.REACT_APP_BB1_PRICE} ETH`,
	avatarPath: 'contracts/bb1/avatar',
	contractAssetPath: 'contracts/bb1',
	// NFT_ROOT_ASSET_URL: 'https://stickiesfundev.imgix.net/bodacious-bears/avatars',
	NFT_ROOT_ASSET_URL: 'https://stickiesfundev.imgix.net', /// contracts/bb1/avatars',
	presaleSweepstakes: 'https://gleam.io/veawO/the-bodacious-bears-whitelist',
	partnershipForm: 'https://docs.google.com/forms/d/e/1FAIpQLSdBmQ8bqNcEEuhPL_5-nvIfvX36FnCFbRjTi5-brLNOTzGbcw/viewform',
	smartContractUrl: 'https://etherscan.io',
	contracts: {
		bb1: process.env.REACT_APP_BB1_CONTRACT_ADDRESS,
	},
	/* api: {
		getNonceToSign: 'https://us-central1-ionic-angular-web3.cloudfunctions.net/getNonceToSign'
	} */
}

export const SOCIAL_LINKS:SocialLinks = {
	twitter: siteData.twitterPage,
	// telegram: siteData.telegramPage,
	// discord: siteData.discordPage,
}
